import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleClaimMappingModel } from 'src/app/components/security/roles/models/roleClaimMapping';
import { RoleModel } from 'src/app/components/security/roles/models/roleModel';
import { ClaimModel } from 'src/app/components/security/claims/models/claimModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';

@Component({
    selector: 'app-roleclaim',
    templateUrl: './manageroleclaim.component.html'
})
export class RoleClaimComponent implements OnInit {
    roleId!: string;
    roleClaimList: RoleClaimMappingModel[] = [];
    claimList: ClaimModel[] = [];
    role: RoleModel = new RoleModel();

    displayedColumns = ['isChecked', 'code', 'description'];
    
    constructor(
        public _restAPI: RestAPIService,
        private route: ActivatedRoute, 
        private router: Router) {
            localStorage["applyRoleFilterValue"] = 'true';
        }

        //#region Get query params
        getQueryParams(): void {
            this.route
                .queryParams
                .subscribe(params => {
                    // Defaults to 0 if no query param provided.
                    let id = params['roleId'] as string;
                    this.roleId = id || '00000000-0000-0000-0000-000000000000';
                    if (this.roleId == '00000000-0000-0000-0000-000000000000') {
                        this.router.navigateByUrl('/security/role');
                    }
                });
        }
        //#endregion
  
    async ngOnInit() {
        this.getQueryParams();
        await this.getRoleClaimList();
        await this.getRoleById();
    }
    
    async getRoleById() {

        this._restAPI.get<RoleModel>(environment.apiURL + 'api/role/' + this.roleId).subscribe({
            next: (data) => {
                this.role = data;
            },
            error: (error) => console.error(error)
        });
    }

    async getRoleClaimList() {
        
        this._restAPI.get<RoleClaimMappingModel[]>(environment.apiURL + 'api/roleclaim/' + this.roleId).subscribe({
            next: (data) => {
                this.roleClaimList = data;
                this.getClaimList();
            },
            error: (error) => console.error(error)
        });
    }

    async getClaimList() {

        this._restAPI.get<ClaimModel[]>(environment.apiURL + 'api/claim/list').subscribe({
            next: (data) => {
                this.claimList = data;

                for (const [index, claim] of this.claimList.entries()) {
                    const item = this.roleClaimList.find(y => y.claimId == claim.id);
                    this.claimList[index].isChecked = (item?.id?.length ?? 0) > 0;
                }

            },
            error: (error) => console.error(error)
        });
    }

    async saveRoleClaim() {
        if (this.role.id != null && this.role.id.length > 0) {
            let postData = [];

            for (const claim of this.claimList) {
                if (claim.isChecked) {
                    postData.push({
                        id: '00000000-0000-0000-0000-000000000000',
                        roleId: this.role.id,
                        claimId: claim.id
                    });
                }
            }

            this._restAPI.put<string>(environment.apiURL + 'api/roleclaim/editbyrole/' + this.role.id, postData).subscribe({
                next: (results) => {
                    this.router.navigateByUrl('/security/role');
                },
                error: (error) => console.error(error)
            });
        }
    }
}